module.exports = __webpack_public_path__ + "static/media/title_rougo_simulation.f85c1c63.svg";